import { httpAuth } from 'config/apiClient'
import endpoints from 'constants/endpoints'
import { ICourseProgress, ICourseProgressRequest } from '../model/courseProgress'

/** The learner's own saved SCORM progress (sales-ms-tasks-v2), or null when the course was never opened. */
export const fetchCourseProgress = async (request: ICourseProgressRequest): Promise<ICourseProgress | null> => {
  const { data } = await httpAuth.get(endpoints.courseProgress, { params: request })
  return data?.success?.course_progress ?? null
}

/**
 * Saves what the course reported (the player's `data`); the server derives the status and marks the
 * sub-task DONE when the course is completed or passed. Returns the server's answer for the player.
 */
export const saveCourseProgress = async (
  request: ICourseProgressRequest,
  data: Record<string, unknown>
): Promise<Record<string, unknown>> => {
  const { data: body } = await httpAuth.put(endpoints.courseProgress, { ...request, data })
  return body?.success ?? {}
}
